import { URLS } from '@constants'

import {
  BarChartRequestType,
  BarChartResponseType,
  CopyBarChartRequestType,
} from '../../types/api/barChart.api'

import { commonAPI } from './common.api'

export const barChartApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    createOrUpdateBarChart: build.mutation<BarChartResponseType, BarChartRequestType>({
      query: data => ({
        url: `${URLS.FRONT_CFG}/diagram`,
        method: 'POST',
        body: data,
      }),
    }),
    copyBarChart: build.mutation<null, CopyBarChartRequestType>({
      query: data => ({
        url: `${URLS.FRONT_CFG}/diagram/copy`,
        method: 'POST',
        body: data,
      }),
    }),
    fetchBarChartById: build.mutation<BarChartResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${URLS.FRONT_CFG}/diagram/id/${id}`,
        method: 'GET',
      }),
    }),
    fetchBarCharts: build.mutation<BarChartResponseType[], null>({
      query: () => ({
        url: `${URLS.FRONT_CFG}/diagram`,
        method: 'GET',
      }),
    }),
    fetchCachedBarCharts: build.query<BarChartResponseType[], null>({
      query: () => ({
        url: `${URLS.FRONT_CFG}/diagram`,
        method: 'GET',
      }),
    }),
    executeBarChartCommand: build.mutation<
      void,
      {
        commandCode: string
        objectCode: string
        params?: any
      }
    >({
      query: ({ commandCode, objectCode, params }) => ({
        url: `/command/objects/${objectCode}/${commandCode}`,
        params,
      }),
    }),
  }),
})

export const {
  useCreateOrUpdateBarChartMutation,
  useFetchBarChartByIdMutation,
  useFetchBarChartsMutation,
  useCopyBarChartMutation,
  useExecuteBarChartCommandMutation,
  useFetchCachedBarChartsQuery,
} = barChartApi
